import config from "../../app.json";
import axios from "axios";

import "./applications.scss";
import { Context } from "../../Reducers/Store";
import React, { useEffect, useContext, useState, useRef } from "react";
import HootSuiteAvatar from "../../Assets/Images/hootsuite.svg";
import { Button } from "react-bootstrap";
import AlertComponent from "../AlertComponent";

function Applications(props) {
  const [state, dispatch] = useContext(Context);
  const [hasHst, setHasHst] = useState(false);
  const newWindowRef = useRef(null);

  const checkLocalStorageEntry = () => {
    setHasHst(localStorage.getItem("hst")?.length > 0);
  };

  useEffect(() => {
    checkLocalStorageEntry();
  }, [0]);

  useEffect(() => {
    const interval = setInterval(checkLocalStorageEntry, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (state?.hootSuiteToken) {
      newWindowRef.current.close();
    }
  }, [state?.hootSuiteToken]);

  const width = 500;
  const height = 600;

  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 3;

  const openAuthPopup = () => {
    const authUrl = `${config.oauthConfig.authorizeUrl}?response_type=token&client_id=${config.oauthConfig.clientId}&redirect_uri=${encodeURIComponent(
      config.oauthConfig.redirectUri
    )}&scope=${config.oauthConfig.scopes.join("&scope=")}`;

    newWindowRef.current = window.open(authUrl, "oauthPopup", `width=${width},height=${height},left=${left},top=${top}`);
  };

  const removeHst = () => {
    try {
      localStorage.removeItem("hst");
      setHasHst(false);
      AlertComponent("Success", "Hootsuite has been successfully deauthorized.");
    } catch {
      AlertComponent("Error", "Ops, Something went wrong deauthorizing hootsuite. Try again in a few minutes.");
    }
  };

  const getDateText = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.toLocaleString("default", { month: "short" });
    const currentYear = currentDate.getFullYear();

    const formattedDate = `${currentMonth} ${currentYear}`;

    if (hasHst) {
      return formattedDate;
    } else {
      return "";
    }
  };

  return (
    <div className="applications-tab">
      <div className="applications-row">
        <h2>Applications</h2>
      </div>
      <div className="applications-container">
        <div className="applications-card">
          <div className="applications-image">
            <img src={HootSuiteAvatar} />
          </div>
          <div className="applications-content">
            <div className="applications-name">
              <div className="user-name">Hootsuite</div>
            </div>
            <small className="text-muted">{getDateText()}</small>
          </div>
          <div className="applications-login">
            {!hasHst && <Button onClick={openAuthPopup}>Authorize</Button>}
            {hasHst && (
              <Button variant="outline-secondary" onClick={removeHst}>
                Deauthorize
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Applications;
